import React, { useState } from 'react';
import './RelatoriosPorTurma.css';

const RelatoriosPorTurma = () => {
  const [selectedTurma, setSelectedTurma] = useState('all');
  const [selectedPeriod, setSelectedPeriod] = useState('bimestre');
  const [reportType, setReportType] = useState('completo');

  const turmas = [
    { id: '9a', name: '9º ano A', professor: 'Prof. Maria Santos', alunos: 25 },
    { id: '9b', name: '9º ano B', professor: 'Prof. Carlos Ferreira', alunos: 23 },
    { id: '8a', name: '8º ano A', professor: 'Prof. Roberta Lima', alunos: 28 },
    { id: '8b', name: '8º ano B', professor: 'Prof. Marcos Silva', alunos: 26 }
  ];

  const periods = [
    { id: 'semana', label: 'Última Semana' },
    { id: 'bimestre', label: 'Bimestre Atual' },
    { id: 'trimestre', label: 'Trimestre' },
    { id: 'semestre', label: 'Semestre' },
    { id: 'ano', label: 'Ano Letivo' }
  ];

  const reportTypes = [
    { id: 'completo', label: 'Relatório Completo', icon: '📊' },
    { id: 'notas', label: 'Desempenho Geral', icon: '📈' },
    { id: 'frequencia', label: 'Frequência', icon: '📋' },
    { id: 'comparativo', label: 'Comparativo', icon: '📊' }
  ];

  const generateTurmaReport = (turmaId) => {
    const turma = turmas.find(t => t.id === turmaId);
    if (!turma) return null;

    return {
      turma,
      period: selectedPeriod,
      overview: {
        totalAlunos: turma.alunos,
        mediaGeral: 8.4,
        taxaAprovacao: 92.5,
        frequenciaGeral: 94.2,
        desempenho: 'Bom'
      },
      subjects: {
        matematica: {
          media: 8.2,
          aprovados: 23,
          recuperacao: 2,
          reprovados: 0,
          distribuicao: {
            excelente: 8,
            bom: 12,
            regular: 4,
            baixo: 1
          }
        },
        portugues: {
          media: 8.6,
          aprovados: 24,
          recuperacao: 1,
          reprovados: 0,
          distribuicao: {
            excelente: 10,
            bom: 11,
            regular: 3,
            baixo: 1
          }
        },
        historia: {
          media: 8.8,
          aprovados: 25,
          recuperacao: 0,
          reprovados: 0,
          distribuicao: {
            excelente: 12,
            bom: 10,
            regular: 3,
            baixo: 0
          }
        },
        ciencias: {
          media: 7.9,
          aprovados: 22,
          recuperacao: 3,
          reprovados: 0,
          distribuicao: {
            excelente: 6,
            bom: 10,
            regular: 7,
            baixo: 2
          }
        }
      },
      attendance: {
        totalAulas: 200,
        mediaPresencas: 188.4,
        mediaAusencias: 11.6,
        taxaPresenca: 94.2,
        detalhes: 'Excelente frequência geral, poucas ausências não justificadas'
      },
      rankings: [
        { aluno: 'Mariana Souza', media: 9.4, posicao: 1 },
        { aluno: 'João Silva', media: 9.1, posicao: 2 },
        { aluno: 'Lucas Mendes', media: 8.9, posicao: 3 },
        { aluno: 'Ana Costa', media: 8.7, posicao: 4 },
        { aluno: 'Pedro Oliveira', media: 8.5, posicao: 5 }
      ],
      evolution: [
        { periodo: '1º Bimestre', media: 8.1, aprovacao: 88 },
        { periodo: '2º Bimestre', media: 8.3, aprovacao: 90 },
        { periodo: '3º Bimestre', media: 8.5, aprovacao: 92 },
        { periodo: '4º Bimestre', media: 8.7, aprovacao: 94 }
      ],
      highlights: {
        positives: [
          'Melhora constante no desempenho geral',
          'Alta taxa de participação nas aulas',
          'Bom relacionamento entre os alunos',
          'Excelente frequência geral'
        ],
        concerns: [
          'Dificuldades em ciências precisam de atenção',
          'Alguns alunos com dificuldade em matemática',
          'Necessidade de mais atividades práticas'
        ],
        recommendations: [
          'Implementar aulas de reforço para ciências',
          'Criar grupos de estudo para matemática',
          'Aumentar atividades práticas em todas as disciplinas',
          'Desenvolver projetos interdisciplinares'
        ]
      }
    };
  };

  const currentReport = selectedTurma !== 'all' ? generateTurmaReport(selectedTurma) : null;

  const getPerformanceColor = (value) => {
    if (value >= 9) return '#10b981';
    if (value >= 7) return '#3b82f6';
    if (value >= 5) return '#f59e0b';
    return '#ef4444';
  };

  const getGradeDistribution = (distribuicao) => {
    const total = Object.values(distribuicao).reduce((acc, val) => acc + val, 0);
    return Object.entries(distribuicao).map(([level, count]) => ({
      level: level.charAt(0).toUpperCase() + level.slice(1),
      count,
      percentage: ((count / total) * 100).toFixed(1)
    }));
  };

  return (
    <div className="relatorios-turma-container">
      <div className="relatorios-header">
        <h2>👥 Relatórios por Turma</h2>
        <p>Visualize relatórios e estatísticas da turma</p>
      </div>

      <div className="controls-section">
        <div className="control-row">
          <div className="control-group">
            <label>Turma:</label>
            <select 
              value={selectedTurma} 
              onChange={(e) => setSelectedTurma(e.target.value)}
              className="turma-select"
            >
              <option value="all">Selecione uma turma...</option>
              {turmas.map(turma => (
                <option key={turma.id} value={turma.id}>
                  {turma.name} - {turma.professor}
                </option>
              ))}
            </select>
          </div>

          <div className="control-group">
            <label>Período:</label>
            <div className="period-buttons">
              {periods.map(period => (
                <button
                  key={period.id}
                  className={`period-btn ${selectedPeriod === period.id ? 'active' : ''}`}
                  onClick={() => setSelectedPeriod(period.id)}
                >
                  {period.label}
                </button>
              ))}
            </div>
          </div>

          <div className="control-group">
            <label>Tipo de Relatório:</label>
            <div className="report-type-buttons">
              {reportTypes.map(type => (
                <button
                  key={type.id}
                  className={`report-type-btn ${reportType === type.id ? 'active' : ''}`}
                  onClick={() => setReportType(type.id)}
                >
                  <span className="report-icon">{type.icon}</span>
                  <span className="report-label">{type.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {selectedTurma === 'all' ? (
        <div className="turmas-grid">
          <div className="grid-header">
            <h3>Selecione uma Turma</h3>
            <p>Escolha uma turma para visualizar seu relatório detalhado</p>
          </div>
          <div className="turmas-cards">
            {turmas.map(turma => (
              <div 
                key={turma.id}
                className="turma-card"
                onClick={() => setSelectedTurma(turma.id)}
              >
                <div className="turma-header">
                  <h4>{turma.name}</h4>
                  <span className="turma-professor">{turma.professor}</span>
                </div>
                <div className="turma-stats">
                  <div className="stat">
                    <span className="stat-icon">👥</span>
                    <div className="stat-info">
                      <span className="stat-value">{turma.alunos}</span>
                      <span className="stat-label">Alunos</span>
                    </div>
                  </div>
                  <div className="stat">
                    <span className="stat-icon">📊</span>
                    <div className="stat-info">
                      <span className="stat-value">8.4</span>
                      <span className="stat-label">Média</span>
                    </div>
                  </div>
                  <div className="stat">
                    <span className="stat-icon">📈</span>
                    <div className="stat-info">
                      <span className="stat-value">94%</span>
                      <span className="stat-label">Frequência</span>
                    </div>
                  </div>
                </div>
                <div className="card-arrow">→</div>
              </div>
            ))}
          </div>
        </div>
      ) : currentReport && (
        <div className="report-content">
          <div className="report-header">
            <div className="turma-header-info">
              <div className="turma-icon">👥</div>
              <div className="turma-details">
                <h3>{currentReport.turma.name}</h3>
                <span className="turma-professor-large">{currentReport.turma.professor}</span>
                <span className="report-period">Período: {periods.find(p => p.id === selectedPeriod)?.label}</span>
              </div>
            </div>
            <div className="report-actions">
              <button className="action-btn print">
                🖨️ Imprimir
              </button>
              <button className="action-btn export">
                📥 Exportar PDF
              </button>
              <button className="action-btn share">
                📤 Compartilhar
              </button>
            </div>
          </div>

          <div className="overview-section">
            <h4>📊 Visão Geral</h4>
            <div className="overview-cards">
              <div className="overview-card">
                <div className="card-icon">👥</div>
                <div className="card-content">
                  <span className="card-value">{currentReport.overview.totalAlunos}</span>
                  <span className="card-label">Total de Alunos</span>
                </div>
              </div>
              <div className="overview-card">
                <div className="card-icon">📈</div>
                <div className="card-content">
                  <span className="card-value" style={{ color: getPerformanceColor(currentReport.overview.mediaGeral) }}>
                    {currentReport.overview.mediaGeral}
                  </span>
                  <span className="card-label">Média Geral</span>
                </div>
              </div>
              <div className="overview-card">
                <div className="card-icon">✅</div>
                <div className="card-content">
                  <span className="card-value" style={{ color: getPerformanceColor(currentReport.overview.taxaAprovacao) }}>
                    {currentReport.overview.taxaAprovacao}%
                  </span>
                  <span className="card-label">Taxa de Aprovação</span>
                </div>
              </div>
              <div className="overview-card">
                <div className="card-icon">📋</div>
                <div className="card-content">
                  <span className="card-value" style={{ color: getPerformanceColor(currentReport.overview.frequenciaGeral) }}>
                    {currentReport.overview.frequenciaGeral}%
                  </span>
                  <span className="card-label">Frequência Geral</span>
                </div>
              </div>
            </div>
          </div>

          {(reportType === 'completo' || reportType === 'notas') && (
            <div className="subjects-section">
              <h4>📝 Desempenho por Disciplina</h4>
              <div className="subjects-grid">
                {Object.entries(currentReport.subjects).map(([subject, data]) => (
                  <div key={subject} className="subject-card">
                    <div className="subject-header">
                      <h5>{subject.charAt(0).toUpperCase() + subject.slice(1)}</h5>
                      <div className="subject-average">
                        <span className="average-value" style={{ color: getPerformanceColor(data.media) }}>
                          {data.media}
                        </span>
                      </div>
                    </div>
                    <div className="subject-stats">
                      <div className="subject-stat">
                        <span className="stat-label">Aprovados</span>
                        <span className="stat-value approved">{data.aprovados}</span>
                      </div>
                      <div className="subject-stat">
                        <span className="stat-label">Recuperação</span>
                        <span className="stat-value recovery">{data.recuperacao}</span>
                      </div>
                      <div className="subject-stat">
                        <span className="stat-label">Reprovados</span>
                        <span className="stat-value failed">{data.reprovados}</span>
                      </div>
                    </div>
                    <div className="grade-distribution">
                      <span className="distribution-label">Distribuição:</span>
                      <div className="distribution-bars">
                        {getGradeDistribution(data.distribuicao).map((item, index) => (
                          <div key={index} className="distribution-item">
                            <span className="level-label">{item.level}</span>
                            <div className="bar-container">
                              <div 
                                className="bar"
                                style={{ 
                                  width: `${item.percentage}%`,
                                  backgroundColor: getPerformanceColor(
                                    item.level === 'Excelente' ? 10 : 
                                    item.level === 'Bom' ? 8 : 
                                    item.level === 'Regular' ? 6 : 4
                                  )
                                }}
                              ></div>
                            </div>
                            <span className="percentage">{item.percentage}%</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {(reportType === 'completo' || reportType === 'frequencia') && (
            <div className="attendance-section">
              <h4>📈 Frequência da Turma</h4>
              <div className="attendance-card">
                <div className="attendance-stats">
                  <div className="attendance-stat">
                    <span className="stat-icon">📚</span>
                    <div className="stat-info">
                      <span className="stat-value">{currentReport.attendance.totalAulas}</span>
                      <span className="stat-label">Total de Aulas</span>
                    </div>
                  </div>
                  <div className="attendance-stat">
                    <span className="stat-icon">✅</span>
                    <div className="stat-info">
                      <span className="stat-value present">{currentReport.attendance.mediaPresencas.toFixed(1)}</span>
                      <span className="stat-label">Média de Presenças</span>
                    </div>
                  </div>
                  <div className="attendance-stat">
                    <span className="stat-icon">❌</span>
                    <div className="stat-info">
                      <span className="stat-value absent">{currentReport.attendance.mediaAusencias.toFixed(1)}</span>
                      <span className="stat-label">Média de Ausências</span>
                    </div>
                  </div>
                  <div className="attendance-stat">
                    <span className="stat-icon">📊</span>
                    <div className="stat-info">
                      <span className="stat-value" style={{ color: getPerformanceColor(currentReport.attendance.taxaPresenca) }}>
                        {currentReport.attendance.taxaPresenca}%
                      </span>
                      <span className="stat-label">Taxa de Presença</span>
                    </div>
                  </div>
                </div>
                <div className="attendance-observation">
                  <span className="observation-label">📋 Observação:</span>
                  <p>{currentReport.attendance.detalhes}</p>
                </div>
              </div>
            </div>
          )}

          {reportType === 'completo' && (
            <div className="rankings-section">
              <h4>🏆 Ranking da Turma</h4>
              <div className="rankings-card">
                <div className="rankings-list">
                  {currentReport.rankings.map((student, index) => (
                    <div key={index} className="ranking-item">
                      <div className="ranking-position">
                        <span className="position-number">#{student.posicao}</span>
                      </div>
                      <div className="ranking-info">
                        <span className="student-name">{student.aluno}</span>
                        <span className="student-media">Média: {student.media}</span>
                      </div>
                      <div className="ranking-badge">
                        {student.posicao === 1 && '🥇'}
                        {student.posicao === 2 && '🥈'}
                        {student.posicao === 3 && '🥉'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {reportType === 'completo' && (
            <div className="evolution-section">
              <h4>📈 Evolução do Desempenho</h4>
              <div className="evolution-card">
                <div className="evolution-chart">
                  {currentReport.evolution.map((period, index) => (
                    <div key={index} className="evolution-item">
                      <div className="evolution-period">{period.periodo}</div>
                      <div className="evolution-metrics">
                        <div className="metric">
                          <span className="metric-label">Média</span>
                          <span className="metric-value" style={{ color: getPerformanceColor(period.media) }}>
                            {period.media}
                          </span>
                        </div>
                        <div className="metric">
                          <span className="metric-label">Aprovação</span>
                          <span className="metric-value" style={{ color: getPerformanceColor(period.aprovacao) }}>
                            {period.aprovacao}%
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {reportType === 'completo' && (
            <div className="highlights-section">
              <h4>🎯 Destaques e Recomendações</h4>
              <div className="highlights-grid">
                <div className="highlight-card positives">
                  <h5>✅ Pontos Positivos</h5>
                  <ul>
                    {currentReport.highlights.positives.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className="highlight-card concerns">
                  <h5>⚠️ Pontos de Atenção</h5>
                  <ul>
                    {currentReport.highlights.concerns.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className="highlight-card recommendations">
                  <h5>📋 Recomendações</h5>
                  <ul>
                    {currentReport.highlights.recommendations.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RelatoriosPorTurma;
